import { type QSetConditionsTags } from '@exam-management/graphql';

const DIFFICULTY_LABEL = {
  ['ง่าย']: 'ง่าย',
  ['กลาง']: 'กลาง',
  ['ยาก']: 'ยาก',
};

export function formatQuestionDifficultyTags(tags: QSetConditionsTags[]) {
  const formattedTags = Object.keys(DIFFICULTY_LABEL).map((difficulty) => {
    const needTotal = tags.find((tag) => tag.tag.name === difficulty)?.count;
    return `${difficulty}: ${needTotal ?? '-'} ข้อ`;
  });

  return formattedTags.length ? formattedTags.join(', ') : '-';
}
